// Reklam Bannerları Konfigürasyonu
// Bu dosyayı düzenleyerek bannerları kolayca değiştirebilirsiniz
import { categoryPath } from '../utils/categoryUrl';

export const bannerConfig = {
  // Banner değişim süresi (milisaniye)
  changeInterval: 10000, // 10 saniye
  
  // Banner'lar
  banners: [
    {
      id: 1,
      title: "🍰 Yeni Ürünler",
      description: "Taze baklavalar ve cheesecake'ler kapınızda",
      link: "/products",
      active: true,
      translations: {
        tr: { title: "🍰 Yeni Ürünler", description: "Taze baklavalar ve cheesecake'ler kapınızda" },
        en: { title: "🍰 New Products", description: "Fresh baklava and cheesecakes at your door" },
        nl: { title: "🍰 Nieuwe Producten", description: "Verse baklava en cheesecakes aan uw deur" },
        fr: { title: "🍰 Nouveaux Produits", description: "Baklava frais et cheesecakes à votre porte" }
      }
    },
    {
      id: 2,
      title: "🚚 Ücretsiz Kargo",
      description: "€50 ve üzeri siparişlerde ücretsiz teslimat",
      link: "/products",
      active: true,
      translations: {
        tr: { title: "🚚 Ücretsiz Kargo", description: "€50 ve üzeri siparişlerde ücretsiz teslimat" },
        en: { title: "🚚 Free Shipping", description: "Free delivery on orders over €50" },
        nl: { title: "🚚 Gratis Verzending", description: "Gratis bezorging bij bestellingen boven €50" },
        fr: { title: "🚚 Livraison Gratuite", description: "Livraison gratuite pour les commandes de plus de €50" }
      }
    },
    {
      id: 3,
      title: "🎉 %20 İndirim",
      description: "Tüm tatlılarda özel indirim fırsatı",
      link: "/products",
      active: true,
      translations: {
        tr: { title: "🎉 %20 İndirim", description: "Tüm tatlılarda özel indirim fırsatı" },
        en: { title: "🎉 20% Off", description: "Special discount on all desserts" },
        nl: { title: "🎉 20% Korting", description: "Speciale korting op alle desserts" },
        fr: { title: "🎉 20% de Réduction", description: "Réduction spéciale sur tous les desserts" }
      }
    },
    {
      id: 4,
      title: "⭐ 4.9 Puan",
      description: "Müşteri memnuniyeti ile hizmet veriyoruz",
      link: "/about",
      active: true,
      translations: {
        tr: { title: "⭐ 4.9 Puan", description: "Müşteri memnuniyeti ile hizmet veriyoruz" },
        en: { title: "⭐ 4.9 Rating", description: "We serve with customer satisfaction" },
        nl: { title: "⭐ 4.9 Beoordeling", description: "We serveren met klanttevredenheid" },
        fr: { title: "⭐ 4.9 Note", description: "Nous servons avec satisfaction client" }
      }
    },
    {
      id: 5,
      title: "📞 Hızlı Sipariş",
      description: "WhatsApp ile anında sipariş verebilirsiniz",
      link: "/contact",
      active: true,
      translations: {
        tr: { title: "📞 Hızlı Sipariş", description: "WhatsApp ile anında sipariş verebilirsiniz" },
        en: { title: "📞 Quick Order", description: "Order instantly via WhatsApp" },
        nl: { title: "📞 Snelle Bestelling", description: "Bestel direct via WhatsApp" },
        fr: { title: "📞 Commande Rapide", description: "Commandez instantanément via WhatsApp" }
      }
    },
    {
      id: 6,
      title: "🎂 Özel Günler",
      description: "Doğum günü ve düğünler için özel pastalar",
      link: categoryPath('tatlılar', 'pasta'),
      active: false,
      translations: {
        tr: { title: "🎂 Özel Günler", description: "Doğum günü ve düğünler için özel pastalar" },
        en: { title: "🎂 Special Days", description: "Special cakes for birthdays and weddings" },
        nl: { title: "🎂 Speciale Dagen", description: "Speciale taarten voor verjaardagen en bruiloften" },
        fr: { title: "🎂 Jours Spéciaux", description: "Gâteaux spéciaux pour anniversaires et mariages" }
      }
    },
    {
      id: 7,
      title: "🌙 Ramazan Özel",
      description: "Ramazan ayına özel tatlılar ve iftar menüleri",
      link: categoryPath('tatlılar'),
      active: false,
      translations: {
        tr: { title: "🌙 Ramazan Özel", description: "Ramazan ayına özel tatlılar ve iftar menüleri" },
        en: { title: "🌙 Ramadan Special", description: "Special desserts and iftar menus for Ramadan" },
        nl: { title: "🌙 Ramadan Speciaal", description: "Speciale desserts en iftar menu's voor Ramadan" },
        fr: { title: "🌙 Spécial Ramadan", description: "Desserts spéciaux et menus iftar pour le Ramadan" }
      }
    }
  ]
};

// Aktif bannerları filtrele
export const getActiveBanners = () => {
  return bannerConfig.banners.filter(banner => banner.active);
};

// Banner güncelleme fonksiyonu
export const updateBanner = (id, updates) => {
  const bannerIndex = bannerConfig.banners.findIndex(banner => banner.id === id);
  if (bannerIndex !== -1) {
    bannerConfig.banners[bannerIndex] = {
      ...bannerConfig.banners[bannerIndex],
      ...updates
    };
  }
};

// Banner silme fonksiyonu (aktif durumunu değiştir)
export const toggleBanner = (id) => {
  const banner = bannerConfig.banners.find(banner => banner.id === id);
  if (banner) {
    banner.active = !banner.active;
  }
};
